import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=ca4f9a2c&scoped=true&"
import script from "./profit.vue?vue&type=script&lang=js&"
export * from "./profit.vue?vue&type=script&lang=js&"
import style0 from "./profit.vue?vue&type=style&index=0&id=ca4f9a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f9a2c",
  null
  
)

export default component.exports